import React from "react";
import { observer, inject } from "mobx-react";
import { NavLink, withRouter } from "react-router-dom";
import { isMoscowSiteCode, isMainSiteCode } from "Utils/siteConfig";
import { createDownload } from "Utils/functionalUtils";
import { generateUrl } from "Services/withDefaultParams";
import withDefaultParams from "Services/withDefaultParams";
import { AggrementPdfFile } from "Constants/url";
import { FooterMenu, FooterMenuCol } from "ComponentsUI/Footer";
import { MenuItem, MenuItemMain } from "ComponentsUI/Navigation";

var Routes = require("Configs/routes");

@withRouter
@withDefaultParams
@inject("ApplicationModel")
@observer
export default class FooterMenuContainer extends React.Component {
    onClickHandler(goal) {}

    onClickLogoHandler() {}

    onClickDownloadHandler(elem) {
        createDownload(elem);
    }

    render() {
        let textConfig = this.props.ApplicationModel.text;
        let siteConfig = this.props.ApplicationModel.__CONFIG_SITES;
        let siteCode = this.props.ApplicationModel.siteCode;
        let currentRegionUrl = this.props.ApplicationModel.currentRegion?.url;

        let regionUrl = this.props.match.params.regionUrl;
        let arrayNotRegionUrl = [
            "providers",
            "news",
            "reviews",
            "compare",
            "actions",
            "rate",
            "rates",
            "orders",
            "business",
            "rating",
            "address",
            "terms-of-use",
            "personal-data",
            "feedback",
            "about",
            "contact-feedback",
        ];
        let regionUrlReal =
            arrayNotRegionUrl.indexOf(regionUrl) >= 0 ? "" : regionUrl;

        let defaultUrl = generateUrl(
            Routes.Default.route,
            {
                regionUrl: regionUrlReal,
            },
            currentRegionUrl
        );

        let providerUrl = generateUrl(
            Routes.Providers.route,
            {
                regionUrl: regionUrlReal,
            },
            currentRegionUrl
        );

        let ratesUrl = generateUrl(
            Routes.Rates.route,
            {
                regionUrl: regionUrlReal,
            },
            currentRegionUrl
        );

        let actionsUrl = generateUrl(
            Routes.Actions.route,
            {
                regionUrl: regionUrlReal,
            },
            currentRegionUrl
        );

        let reviewsUrl = generateUrl(
            Routes.Reviews.route,
            {
                regionUrl: regionUrlReal,
            },
            currentRegionUrl
        );
        let partnerUrl = generateUrl(
            Routes.Partner.route,
            {
                regionUrl: regionUrlReal,
            },
            currentRegionUrl
        );

        let addressUrl = generateUrl(
            Routes.AddressDistricts.route,
            {
                regionUrl: regionUrlReal,
            },
            currentRegionUrl
        );

        let findInternet = generateUrl(
            Routes.OrderToHome.route,
            {
                regionUrl: regionUrlReal,
            },
            currentRegionUrl
        );

        let termsUrl = generateUrl(
            Routes.TermsOfUse.route,
            {
                regionUrl: regionUrlReal,
            },
            currentRegionUrl
        );

        let personalDataUrl = generateUrl(
            Routes.PersonalData.route,
            {
                regionUrl: regionUrlReal,
            },
            currentRegionUrl
        );

        let personalDataUrlWithAnchor = generateUrl(
            Routes.PersonalData.route,
            {
                regionUrl: regionUrlReal,
                anchorUrl: "#processing",
            },
            currentRegionUrl
        );

        let orderOuthomeUrl = generateUrl(
            Routes.OrderOuthome.route,
            {
                regionUrl: regionUrlReal,
            },
            currentRegionUrl
        );
        let orderOfficeUrl = generateUrl(
            Routes.OrderOffice.route,
            {
                regionUrl: regionUrlReal,
            },
            currentRegionUrl
        );

        const contactsUrl = generateUrl(
            Routes.Contacts.route,
            {
                regionUrl: regionUrlReal,
            },
            currentRegionUrl
        );

        const mobileOperatorsUrl = generateUrl(
            Routes.Operatory.route,
            {
                regionUrl: regionUrlReal,
            },
            currentRegionUrl
        );

        const mobileRatesUrl = generateUrl(
            Routes.RatesMobile.route,
            {
                regionUrl: regionUrlReal,
            },
            currentRegionUrl
        );

        const NomeraUrl = generateUrl(
            Routes.BeautifulNumbers.route,
            {
                regionUrl: regionUrlReal,
            },
            currentRegionUrl
        );

        let defaultData = [
            {
                name: "101internet",
                url: defaultUrl,
                main: true,
                logo:
                    this.props.ApplicationModel.siteConfig &&
                    this.props.ApplicationModel.siteConfig.logo_2,
            },
            [
                {
                    name: textConfig.menuProviders,
                    url: providerUrl,
                    datatest: "main_poviders_downbutton",
                },
                {
                    name: textConfig.rates_home,
                    url: ratesUrl,
                    datatest: "main_rates_downbutton",
                },
                {
                    name: textConfig.menuReviews,
                    url: reviewsUrl,
                    datatest: "main_reviews_downbutton",
                },
                {
                    name: textConfig.actions,
                    url: actionsUrl,
                    datatest: "main_actions_downbutton",
                },
                {
                    name: textConfig.searchByAddress,
                    url: addressUrl,
                    datatest: "main_address_downbutton",
                },
                {
                    name: textConfig.upperMenuFindInternet,
                    url: findInternet,
                    datatest: "main_ordersTo-home_downbutton",
                },
                isMainSiteCode(siteCode)
                    ? {
                          name: textConfig.menuPartner,
                          url: partnerUrl,
                          datatest: "main_aboutPartners_downbutton",
                      }
                    : null,
            ],
            [
                {
                    name: textConfig.mobile_operators,
                    url: mobileOperatorsUrl,
                    datatest: "menu_operatory_downbutton",
                },
                {
                    name: textConfig.mobile_ratesmobile,
                    url: mobileRatesUrl,
                    datatest: "menu_ratesmobile_downbutton",
                },
                {
                    name: textConfig.BEAUTIFUL_NUMBERS,
                    url: NomeraUrl,
                    datatest: "menu_nomera_downbutton",
                },
                {
                    name: textConfig.headerForBusiness,
                    url: orderOfficeUrl,
                    datatest: "menu_ordersOffice_downbutton",
                },
                {
                    name: textConfig.menuOrderOuthome,
                    url: orderOuthomeUrl,
                    datatest: "menu_ordersSat_downbutton",
                },
                {
                    name: textConfig.CAREER,
                    url: "/career",
                    to_another_site: true,
                    datatest: "main_career_downbutton",
                },
                isMainSiteCode(siteCode)
                    ? {
                          name: textConfig.CHARITY,
                          url: "https://levochkin.vc/",
                          to_another_site: true,
                          datatest: "main_1plus1_downbutton",
                      }
                    : null,
                isMainSiteCode(siteCode)
                    ? {
                          name: textConfig.menuContacts,
                          url: contactsUrl,
                          datatest: "main_aboutContacts_downbutton",
                      }
                    : "",
            ],
            [
                !isMainSiteCode(siteCode)
                    ? {
                          name: textConfig.menuPartner,
                          url: partnerUrl,
                          datatest: "main_aboutPartners_downbutton",
                      }
                    : null,
                !isMainSiteCode(siteCode)
                    ? {
                          name: textConfig.menuContacts,
                          url: contactsUrl,
                          datatest: "main_aboutContacts_downbutton",
                      }
                    : "",
                {
                    name: textConfig.termsOfUseMenu,
                    url: termsUrl,
                    datatest: "main_aboutTerms-of-use_downbutton",
                },
                {
                    name: textConfig.personalDataMenu,
                    url: personalDataUrl,
                    datatest: "main_aboutPersonal_downbutton",
                    reduceMarginV2: true,
                },
                !isMainSiteCode(siteCode)
                    ? {
                          name: textConfig.processingPersonalDataMenu,
                          url: personalDataUrlWithAnchor,
                          datatest: "main_processingAboutPersonal_downbutton",
                          reduceMarginV2: true,
                      }
                    : null,
                {
                    name: textConfig.ARTICLES,
                    url: "/articles",
                    to_another_site: true,
                    datatest: "main_articles_downbutton",
                },
                isMainSiteCode(siteCode)
                    ? {
                          name: textConfig.processingPersonalDataMenuPDF,
                          url: AggrementPdfFile["101internet"].processing,
                          download: true,
                          datatest:
                              "main_download_processingAboutPersonal_downbutton",
                          reduceMargin: true,
                      }
                    : null,
                isMainSiteCode(siteCode)
                    ? {
                          name: textConfig.functional_description_footer,
                          url: AggrementPdfFile["101internet"].functional,
                          download: true,
                          datatest:
                              "main_download_functional_description_downbutton",
                          reduceMargin: true,
                      }
                    : null,
                isMainSiteCode(siteCode)
                    ? {
                          name: textConfig.manual,
                          url: AggrementPdfFile["101internet"].manual,
                          download: true,
                          datatest: "main_download_manual_downbutton",
                      }
                    : null,
            ],
        ];

        // let footerArticles = {
        //     name: textConfig.ARTICLES,
        //     url: "https://www.moskvaonline.ru/articles",
        //     to_another_site: true,
        //     datatest: "main_articles_downbutton",
        // };
        // let footer1plus1 = {
        //     name: textConfig.CHARITY,
        //     url: "https://1plus1.101internet.ru/",
        //     to_another_site: true,
        //     datatest: "main_1plus1_downbutton",
        // };
        // if (isMoscowSiteCode(siteCode)) {
        //     defaultData[3].push(footerArticles);
        // }
        // if (isMainSiteCode(siteCode)) {
        //     defaultData[3].push(footer1plus1);
        // }

        return (
            <FooterMenu>
                {defaultData.map((item, index) => {
                    if (item.main) {
                        return (
                            <MenuItemMain
                                key={index}
                                siteCode={siteCode}
                                url={item.url}
                                footerTheme={true}
                                onClickLogo={() => {
                                    this.onClickLogoHandler();
                                }}
                            />
                        );
                    } else {
                        return (
                            <FooterMenuCol key={index} siteCode={siteCode}>
                                {item
                                    .filter(item => !!item)
                                    .map((item, index) => {
                                        if (item.download) {
                                            return (
                                                <MenuItem
                                                    key={index}
                                                    counter={item.counter}
                                                    footerTheme={true}
                                                    purpleColor={true}
                                                    siteCode={siteCode}
                                                    toAnotherSite={
                                                        !item.to_another_site
                                                    }
                                                    clickMenuItem={goal => {
                                                        this.onClickHandler(
                                                            item.goal
                                                        );
                                                    }}
                                                    reduceMargin={
                                                        item.reduceMargin
                                                    }
                                                    reduceMarginV2={
                                                        item.reduceMarginV2
                                                    }
                                                >
                                                    <div
                                                        onClick={() =>
                                                            this.onClickDownloadHandler(
                                                                item
                                                            )
                                                        }
                                                        datatest={item.datatest}
                                                    >
                                                        {item.name}
                                                    </div>
                                                </MenuItem>
                                            );
                                        } else if (item.url) {
                                            return (
                                                <MenuItem
                                                    key={index}
                                                    counter={item.counter}
                                                    footerTheme={true}
                                                    purpleColor={true}
                                                    siteCode={siteCode}
                                                    toAnotherSite={
                                                        !!item.to_another_site
                                                    }
                                                    clickMenuItem={goal => {
                                                        this.onClickHandler(
                                                            item.goal
                                                        );
                                                    }}
                                                    reduceMargin={
                                                        item.reduceMargin
                                                    }
                                                    reduceMarginV2={
                                                        item.reduceMarginV2
                                                    }
                                                >
                                                    {!item.to_another_site ? (
                                                        <NavLink
                                                            to={item.url}
                                                            datatest={
                                                                item.datatest
                                                            }
                                                        >
                                                            {item.name}
                                                        </NavLink>
                                                    ) : (
                                                        <a href={item.url}>
                                                            {item.name}
                                                        </a>
                                                    )}
                                                </MenuItem>
                                            );
                                        } else {
                                            return (
                                                <MenuItem
                                                    key={index}
                                                    counter={item.counter}
                                                    footerTheme={true}
                                                    purpleColor={true}
                                                    siteCode={siteCode}
                                                    clickMenuItem={goal => {
                                                        this.onClickHandler(
                                                            item.goal
                                                        );
                                                    }}
                                                    reduceMargin={
                                                        item.reduceMargin
                                                    }
                                                    reduceMarginV2={
                                                        item.reduceMarginV2
                                                    }
                                                >
                                                    <a>{item.name}</a>
                                                </MenuItem>
                                            );
                                        }
                                    })}
                            </FooterMenuCol>
                        );
                    }
                })}
            </FooterMenu>
        );
    }
}
